import * as React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import {itemCss} from './ltems.module.scss'
import {translate} from "../../helpers/lang";
import {OrderSort} from "../../helpers/sort";


export const Items = ({lang}) => {
  const data = useStaticQuery(graphql`
    {
      allExpertises {
        edges {
          node {
            data {
              color
              display_name {
                en
                fr
              }
              order
              id
              subitems {
                display_name {
                  fr
                  en
                }
                id
                order
              }
            }
          }
        }
      }
    }
  `)

  const arr   =OrderSort( data?.allExpertises?.edges?.[0]?.node?.data   )

  return (
    <div className={'expertises__list'}>
      {arr.map((item , i )=>{
       return <Line lang={lang} item={item} key={i}/>
      })}

    </div>

  );
};


const Line = ({item , lang})=>{
const t = translate(lang , item)

  const orderedSubItems = OrderSort(item.subitems);
  return (
    <div className={"expertises__list-item  "+ itemCss}>
      <div style={{borderColor:'#'+item.color}} className="expertises__circle  ">
        <div  style={{backgroundColor:'#'+item.color}} className="circle"/>
      </div>
      <ul>
        <li>{t('display_name')}</li>
        {orderedSubItems.map((subItem , i)=>{
         return   <SubItem key={i}  lang={lang} subItem={subItem}/>
        })}
      </ul>
    </div>
  )
}

const SubItem =({lang , subItem})=>{

  const t  = translate(lang, subItem);
  return <li title={subItem.id}>
    {t ('display_name')}
  </li>

}